import React, { useState, useContext } from "react";
import "./booking.css";
import { Form, FormGroup, Button, Spinner } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import { BASE_URL } from "../../utils/config";

const Booking = ({ tour }) => {
  const { name, id } = tour;
  const navigate = useNavigate();

  const { user } = useContext(AuthContext);

  const [booking, setBooking] = useState({
    user_id: user && user.data.id,
    tour_name: name,
    name: "",
    email: "",
    phonenumber: "",
    city: "",
    pax: "",
    tour_id: id,
    coupon_code: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setBooking((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const handleClick = async (e) => {
    e.preventDefault();

    const { name, email, phonenumber, city, pax } = booking;
    if (!name || !email || !phonenumber || !city || !pax) {
      alert("Please fill out all required fields.");
      return;
    }

    setLoading(true);
    try {
      if (!user || user === undefined || user === null) {
        setLoading(false);
        return alert("Please sign in");
      }

      const res = await axios.post(
        `${BASE_URL}/send-mail`,
        booking,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (res.status !== 200) {
        setLoading(false);
        return alert(res.data.message);
      }

      navigate("/thank-you");
    } catch (err) {
      setLoading(false);
      alert(err.message);
    }
  };

  return (
    <div className="booking">
      <div className="booking__form">
        <h5>Information </h5>
        <Form className="booking__info-form" onSubmit={handleClick}>
          <FormGroup>
            <input
              type="text"
              placeholder="Full Name"
              id="name"
              required
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <input
              type="email"
              placeholder="Email"
              id="email"
              required
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <input
              type="number"
              placeholder="Mobile Number"
              id="phonenumber"
              required
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <input
              type="text"
              placeholder="City"
              id="city"
              required
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <input
              type="number"
              placeholder="Total Passengers"
              id="pax"
              required
              onChange={handleChange}
              min="1"
            />
          </FormGroup>
          <FormGroup>
            <input
              type="text"
              placeholder="Coupon Code"
              id="coupon_code"
              onChange={handleChange}
            />
          </FormGroup>
        </Form>
      </div>

      <div className="booking__bottom">
        <Button
          className="btn primary__btn w-100 mt-4"
          onClick={handleClick}
          disabled={loading}
        >
          {loading ? <Spinner size="sm" /> : "Book Now"}
        </Button>
      </div>
    </div>
  );
};

export default Booking;
